(function(window, document, $, undefined) {
    $(function() {
        $( "a.ext_link, li.ext_link" ).click(
            function(e) {
                // prevent link from opening
                e.preventDefault();

                // open a modal
                $( this ).attr( "data-toggle", "modal" );
                $( this ).attr( "data-target", "#speedbump" );
                $( 'body' ).css( 'overflow', 'hidden' );
                $( "#speedbump" ).css( 'display', 'flex' );

                //go to link on modal close
                var url = "";
                if ($( this ).attr( "href" ) && $( this ).attr( "href" ).length) {
                    url = $( this ).attr( "href" );
                }
                if ($( this ).find( "a" ).attr( "href" ) && $( this ).find( "a" ).attr( "href" ).length) {
                    url = $( this ).find( "a" ).attr( "href" );
                }

                // set window.open in the button, this is to avoid canceled click events from propagating
                url = "window.open('" + url + "');";
                $( ".btn-modal.btn-continue" ).attr( "onclick", url )

                // Continue button
                $( ".btn-modal.btn-continue" ).click(
                    function() {
                        $( 'body' ).css( 'overflow', 'auto' );
                        $( "#speedbump" ).css( 'display', 'none' );
                        $( ".btn-modal.btn-continue" ).off();
                    }
                );
                // Cancel button
                $( ".btn-modal.btn-close" ).click(
                    function() {
                        $( 'body' ).css( 'overflow', 'auto' );
                        $( "#speedbump" ).css( 'display', 'none' );
                        $( ".btn-modal.btn-close" ).off();
                    }
                );
                // Close button
                $( "#speedbump button.close" ).click(
                    function() {
                        $( 'body' ).css( 'overflow', 'auto' );
                        $( "#speedbump" ).css( 'display', 'none' );
                        $( "#speedbump button.close" ).off();
                    }
                );
            }
        );
    });
})( window, document, jQuery );
